export default __webpack_public_path__ + "static/media/ic_reports.4477ac04.svg";